import 'react';
import { useFullscreenActions } from '@pm2/react-utils';
import { usePm2Modal } from '@pm2/ui-lightbox';
import { componentFrameworkStore } from '@provider/component-framework';
import { InMemoryNavigationProvider } from '@provider/navigation';
import { useSpeechSynthesisConfig } from '@provider/speech-synthesis';
import { SpeechButton } from '@ui/kit';
import { OpgavekompleksetComponent } from '../../../_component.js';
import { lightboxModal } from '../../../_component.style.js';
import { useOpgavekompleksetComponent } from '../../../state/context.data.js';
import { jsx } from 'react/jsx-runtime';

function useOpgavekompleksetFullscreenActions(args) {
  const pm2Modal = usePm2Modal();
  const component = useOpgavekompleksetComponent();
  const speechConfig = useSpeechSynthesisConfig();
  return useFullscreenActions({
    ...args,
    onFullscreenOpen: () => {
      componentFrameworkStore.dispatch(componentFrameworkStore.actions.activateComponent(component.envelope.ID));
    },
    handleOpenInLightboxFallback: () => {
      if (args.componentProps.context === "embedded") {
        args.componentProps.openInLightbox();
      } else {
        pm2Modal.fromComponentFrameworkNode(/*#__PURE__*/jsx(InMemoryNavigationProvider, {
          initialPath: location.pathname,
          children: /*#__PURE__*/jsx(OpgavekompleksetComponent, {
            ...args.componentProps,
            context: "lightbox"
          })
        }), "component-framework.opgavekomplekset", {
          className: lightboxModal,
          buttons: speechConfig.enabled ? [/*#__PURE__*/jsx(SpeechButton, {
            flagPlacement: "top",
            tooltipPlacement: "left"
          }, "speech")] : undefined
        });
      }
    }
  });
}

export { useOpgavekompleksetFullscreenActions };
//# sourceMappingURL=hook.fullscreen.js.map
